import styled from "styled-components";
import { UserStatusCongratulationsBenefitsCardBadgeStyled } from "./UserStatusCongratulationsBenefitsCardStyled";

export const UserStatusCongratulationsBenefitsPromocodeInfoBadgeStyled = styled(UserStatusCongratulationsBenefitsCardBadgeStyled)`
    padding: 0 12px 0 14px;
    position: relative;
    color: var(--background-base);
    background: linear-gradient(139.19deg, #FFDAB9 13.35%, #C2C5FF 67.96%);
`;
